import * as React from 'react';
import { Icon } from 'sos-common/js/components/Icon/icon';

export interface ListInvitaitonsProps {
  canDeletePendingInvitaion: boolean;
  pendingInvitations: Invitation[];
}

export interface ListInvitaionsState {
  enableDeleteButtons: boolean;
}

interface Invitation {
  Roll: string;
  Id: string;
  Epost: string;
  Telefonnummer: string;
  Befattning: string;
  Organisationsnummer: string;
  Skapad: string;
}

/**
 * Lists pending invitations and gives possibility to cancel them.
 */
export class ListPendingInvitations extends React.Component<ListInvitaitonsProps, ListInvitaionsState> {
  constructor(props: ListInvitaitonsProps) {
    super(props);

    this.state = {
      enableDeleteButtons: false,
    };
  }

  renderPendingInvitation = (invitation: Invitation) => {
    return (
      <div className="orgadmin__replist pending-invitations" key={invitation.Id}>
        <div>
          <div className="orgadmin__repname">
            <span>{invitation.Epost}</span>
          </div>
          <div className="orgadmin__repfooter">
            <div className="orgadmin__reprole">{invitation.Roll}</div>
          </div>
        </div>
        <form className="orgadmin__repactions" action={`DeletePendingInvitation/?id=${invitation.Id}`} method="POST">
          <button type="submit" className="stripped-button orgadmin__repdeletebtn">
            <Icon isAriaHidden={true} iconType="fontawesome/trash-alt" className="orgadmin__repactions__trashicon" />
            Återkalla inbjudan
          </button>
        </form>
      </div>
    );
  };

  render() {
    return (
      <>
        <h2>Väntande inbjudningar</h2>
        <p className="compact-text">
          Inbjudna personer får ett mejl där de behöver besvara inbjudan genom att klicka på en länk.
        </p>
        {this.props.pendingInvitations.map(this.renderPendingInvitation)}

        <hr></hr>
      </>
    );
  }
}
